import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { clearSettings } from 'ducks/settings/slices';
import { Slices } from 'ducks/slices';
import { User, UserPayload } from 'ducks/types/store-types';
import { clearUser, setUser } from 'ducks/user/slices';
import { clearStore } from 'ducks/utils';
import { store } from 'store';
import { Andromeda, Sol } from 'utils/axios';
import { deleteStorage } from 'utils/storage';

import { normalizeUser } from './utils';

export const SERVICES = {
  SOL: 1,
  GEMINI: 2,
  HYPERION: 3,
  NOVA: 4,
  ORION: 7,
  ANDROMEDA: 8,
  TITAN: 9,
  LIBRA: 10,
};

export enum AUTHENTICATION_RESULTS {
  UNKNOWN = 0,
  SUCCESS = 1,
  INVALID_LOGIN = 2,
  ACCOUNT_INACTIVE = 3,
  ACCOUNT_LOCKED = 4,
  INVALID_PASSWORD = 5,
  INVALID_ORGANIZATION = 6,
  HASH_MISMATCH = 7,
  INVALID_PRIVATE_KEY = 8,
  NO_DEFAULT_ORGANIZATION = 9,
  SERVICE_DENIED_LOGIN = 10,
}

export const AUTHENTICATION_ERRORS = {
  0: 'unknown',
  1: 'success login',
  2: 'invalid login attempt',
  3: 'account is inactive',
  4: 'account is locked',
  5: 'invalid password',
  6: 'invalid organization',
  7: 'hash mismatch',
  8: 'invalid private key',
  9: 'no default organization',
  10: 'service denied login',
};

export const getUser = createAsyncThunk<User, UserPayload>(
  'user/get',
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const res: AxiosResponse['data'] = await Sol.login(payload);

      const { authentication_result, private_key, public_key } = res.data;

      if (authentication_result === AUTHENTICATION_RESULTS.SUCCESS) {
        Andromeda.persistKeys({ private_key, public_key });
        const user = await normalizeUser(res.data);
        await dispatch(setUser(user));
        return user;
      }
      throw new Error(AUTHENTICATION_ERRORS[authentication_result] || 'uncaught error');
    } catch (error: any) {
      dispatch(setUser({ error: error?.message }));
      return rejectWithValue(error as any);
    }
  },
);
export const logoutUser = createAsyncThunk(`${Slices.USER}/logout`, async () => {
  try {
    store.dispatch(clearUser());
    store.dispatch(clearSettings());
    clearStore();
    deleteStorage();
  } catch {
    throw new Error('Unable to clear store');
  }
});
